import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display"]
  static values = {
    expiresAt: String,
    redirectUrl: String
  }

  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  tick() {
    const remaining = Date.parse(this.expiresAtValue) - Date.now()
    if (remaining <= 0) {
      this.displayTarget.textContent = "00:00"
      clearInterval(this.timer)
      this.displayTarget.textContent = "Sua sessão expirou. Retornando ao evento..."
      window.location.href = this.redirectUrlValue
      return
    }

    const totalSeconds = Math.floor(remaining / 1000)
    const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, "0")
    const seconds = String(totalSeconds % 60).padStart(2, "0")
    this.displayTarget.textContent = `${minutes}:${seconds}`
  }
}
